module.exports = __webpack_public_path__ + "img/Words_art_sunglasses.5cab971f.png";